import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=34e80156"
import script from "./FlipBook.vue?vue&type=script&lang=js"
export * from "./FlipBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports